import React, {
  useMemo,
  useState,
} from "react";

function ProductTable({
  products = [],
}) {

  // =====================================================
  // STATES
  // =====================================================

  const [
    selectedCategory,
    setSelectedCategory,
  ] = useState("All");

  const [
    selectedDate,
    setSelectedDate,
  ] = useState("All");

  // =====================================================
  // CATEGORY FILTER
  // =====================================================

  const categories = useMemo(() => {

    const uniqueCategories = [

      ...new Set(
        products.map(
          (item) =>
            item.master_category
        )
      ),

    ];

    return uniqueCategories.filter(
      Boolean
    );

  }, [products]);

  // =====================================================
  // DATE FILTER
  // =====================================================

  const dates = useMemo(() => {

    const uniqueDates = [

      ...new Set(
        products.map(
          (item) =>
            item.snapshot_date
        )
      ),

    ];

    return uniqueDates.filter(
      Boolean
    );

  }, [products]);

  // =====================================================
  // FILTERED PRODUCTS
  // =====================================================

  const filteredProducts =
    useMemo(() => {

      return products.filter(
        (item) => {

          const categoryMatch =

            selectedCategory ===
              "All" ||

            item.master_category ===
              selectedCategory;

          const dateMatch =

            selectedDate ===
              "All" ||

            item.snapshot_date ===
              selectedDate;

          return (
            categoryMatch &&
            dateMatch
          );
        }
      );

    }, [
      products,
      selectedCategory,
      selectedDate,
    ]);

  // =====================================================
  // EMPTY STATE
  // =====================================================

  if (!products.length) {

    return (

      <div className="table-empty">

        No product data found

      </div>
    );
  }

  // =====================================================
  // RENDER
  // =====================================================

  return (

    <div className="product-table-section">

      {/* =================================================
          HEADER
      ================================================= */}

      <div className="page-header">

        <h2>
          Historical Price Data
        </h2>

        <p>
          Category-wise and
          Date-wise Product
          Comparison Dashboard
        </p>

      </div>

      {/* =================================================
          FILTERS
      ================================================= */}

      <div className="table-filters">

        {/* CATEGORY */}

        <select
          value={
            selectedCategory
          }
          onChange={(e) =>
            setSelectedCategory(
              e.target.value
            )
          }
        >

          <option value="All">

            All Categories

          </option>

          {categories.map(
            (
              category,
              index
            ) => (

              <option
                key={index}
                value={category}
              >

                {category}

              </option>

            )
          )}

        </select>

        {/* DATE */}

        <select
          value={selectedDate}
          onChange={(e) =>
            setSelectedDate(
              e.target.value
            )
          }
        >

          <option value="All">

            All Dates

          </option>

          {dates.map(
            (
              date,
              index
            ) => (

              <option
                key={index}
                value={date}
              >

                {date}

              </option>

            )
          )}

        </select>

      </div>

      {/* =================================================
          TABLE
      ================================================= */}

      <div className="table-wrapper">

        <table className="modern-table">

          {/* =============================================
              HEADER
          ============================================= */}

          <thead>

            <tr>

              <th>
                Product
              </th>

              <th>
                Category
              </th>

              <th>
                Quantity
              </th>

              <th>
                Unit
              </th>

              <th>
                F2B
              </th>

              <th>
                Blinkit
              </th>

              <th>
                Zepto
              </th>

              <th>
                BigBasket
              </th>

              <th>
                Cheapest
              </th>

              <th>
                Date
              </th>

            </tr>

          </thead>

          {/* =============================================
              BODY
          ============================================= */}

          <tbody>

            {filteredProducts.map(
              (
                item,
                index
              ) => (

                <tr key={index}>

                  {/* PRODUCT */}

                  <td
                    style={{
                      fontWeight:
                        "700",

                      minWidth:
                        "260px",
                    }}
                  >

                    {
                      item.master_product
                    }

                  </td>

                  {/* CATEGORY */}

                  <td>

                    {
                      item.master_category
                    }

                  </td>

                  {/* QUANTITY */}

                  <td>

                    {
                      item.quantity_value
                    }

                  </td>

                  {/* UNIT */}

                  <td>

                    {
                      item.quantity_unit
                    }

                  </td>

                  {/* F2B */}

                  <td>

                    {
                      item.farm2bag_price !=
                      null

                        ? `₹ ${item.farm2bag_price}`

                        : "-"
                    }

                  </td>

                  {/* BLINKIT */}

                  <td>

                    {
                      item.blinkit_price !=
                      null

                        ? `₹ ${item.blinkit_price}`

                        : "-"
                    }

                  </td>

                  {/* ZEPTO */}

                  <td>

                    {
                      item.zepto_price !=
                      null

                        ? `₹ ${item.zepto_price}`

                        : "-"
                    }

                  </td>

                  {/* BIGBASKET */}

                  <td>

                    {
                      item.bigbasket_price !=
                      null

                        ? `₹ ${item.bigbasket_price}`

                        : "-"
                    }

                  </td>

                  {/* CHEAPEST */}

                  <td>

                    <span
                      className={
                        (
                          item.cheapest_platform ||
                          ""
                        )
                          .toLowerCase()
                          .includes(
                            "farm2bag"
                          )

                          ? "badge badge-success"

                          : "badge badge-danger"
                      }
                    >

                      {
                        item.cheapest_platform ??
                        "-"
                      }

                    </span>

                  </td>

                  {/* DATE */}

                  <td>

                    {
                      item.snapshot_date
                    }

                  </td>

                </tr>

              )
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
}

export default ProductTable;